import React from "react";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { Result, Spin } from 'antd';
import moment from "moment";
import { Util } from "common/util";
import { getPayrollForTax } from "services/payroll_report";
import withDataTable from "../../withDataTable";

const pathName = "/reports/payroll/payroll_for_tax";
const columns = [
  {
    title: <div>No&deg;</div>,
    dataIndex: "no",
    key: "no",
    width: 100,
    align: "center",
    render: (no, record, index) => index + 1
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name"
  },
  {
    title: "EMP#",
    dataIndex: "empCode",
    key: "empCode"
  },
  {
    title: "D.O.B",
    dataIndex: "dob",
    key: "dob",
    render: dob => moment(dob).format("DD/MM/YYYY")
  },
  {
    title: "Employment Date",
    dataIndex: "joinDate",
    key: "joinDate",
    render: joinDate => moment(joinDate).format("DD/MM/YYYY")
  },
  {
    title: "Position",
    dataIndex: "position",
    key: "position"
  },
  {
    title: "Spouse",
    dataIndex: "spouse",
    key: "spouse"
  },
  {
    title: "Kid",
    dataIndex: "kid",
    key: "kid"
  },
  {
    title: "Salary",
    dataIndex: "grossSalary",
    key: "grossSalary",
    align: "right",
    render: grossSalary => Util.getInstance().formatCurrency(grossSalary)
  },
  {
    title: "Total Allowance",
    dataIndex: "totalAllowance",
    key: "totalAllowance",
    align: "right",
    render: totalAllowance => Util.getInstance().formatCurrency(totalAllowance)
  },
  {
    title: "Taxable Salary",
    dataIndex: "taxableSalary",
    key: "taxableSalary",
    align: "right",
    render: (taxableSalary, record) => record.taxRate > 0 ? Util.getInstance().formatCurrency(taxableSalary) : ""
  }
];

const handleSearch = (e) => {
  const value = e.target.value;
  const params = new URLSearchParams(document.location.search);

  if (value) {
    params.set("search", value)
  } else {
    params.delete("search");
  }

  Util.getInstance().pushParamsToURL(pathName, params.toString());
};

const getData = () => {
  let option = {};
  const params = new URLSearchParams(document.location.search);
  if (params.get("date")) option["date"] = params.get("date");
  if (params.get("search")) option["search"] = params.get("search");

  if (Object.keys(option).length === 0) {
    return new Promise((resolve) => resolve([]));
  } else {
    return getPayrollForTax(option);
  }
};

const componentWillMount = () => {
  const params = new URLSearchParams(document.location.search);
  if (!params.get("date")) params.set("date", moment().format("YYYY-MM"));
  Util.getInstance().pushParamsToURL(pathName, params.toString());
};

function ExportFormLoader() {
  const [loading, setLoading] = React.useState(true);
  const [result, setResult] = React.useState(null);
  const navigate = useNavigate();
  const params = new URLSearchParams(document.location.search);

  React.useEffect(() => {
    let option = {};
    if (params.has("date")) option["date"] = params.get("date");
    if (params.has("search")) option["search"] = params.get("search");
    
    option["isExport"] = true;

    getPayrollForTax(option)
      .then((response) => {
        if (response) {
          setResult(response);
        }
      }).catch(error => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      .finally(() => setLoading(false));

    // eslint-disable-next-line
  }, []);
  return (
    <>
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            height: "24vh",
            display: "flex",
            alignItems: "center",
          }}
        ></Spin>
      ) : (
        <Result
          status="success"
          title="Successfully exported payroll for tax!"
          extra={[
            <div style={{ marginBottom: 25 }}>
              <a key="1" className="ant-btn ant-btn-dashed" href={result ? result.link : "#"}>
                {t("text_download_file_xlsx")}
              </a>
            </div>
          ]}
        />
      )}
    </>
  );
}

export default withDataTable({
  title: "Payroll Report",
  subTitle: "Payroll For E-Filling",
  backLink: "/reports/payroll",
  showDate: true,
  showExport: true,
  dateFormat: "MM/YYYY",
  datePlaceholder: t("text_mm_yyyy"),
  pathName,
  buttonOption: ExportFormLoader,
  pickerDate: "month",
  customEmptyMessage: t("text_please_select_date_and_employee"),
  columns,
  componentWillMount,
  handleSearch,
  getData,
});
